"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelistMatcherContext = void 0;
var sets_1 = require("../../utils/lang/sets");
var constants_1 = require("../../logger/constants");
function whitelistMatcherContext(log, ruleAttr) {
    return function whitelistMatcher(runtimeAttr) {
        var isInWhitelist = ruleAttr.has(runtimeAttr);
        log.debug(constants_1.ENGINE_MATCHER_WHITELIST, [runtimeAttr, (0, sets_1.setToArray)(ruleAttr).join(','), isInWhitelist]);
        return isInWhitelist;
    };
}
exports.whitelistMatcherContext = whitelistMatcherContext;
